import { ColumnHeightOutlined, PauseCircleOutlined } from "@ant-design/icons";
import CustomTag from "./CustomTag";
import React from "react";
import FanRunOperationsSettingsDTO from "src/models/FanRunOperationsSettingsDTO";
import FanOperationType from "src/consts/FanOperationType";
import FanDTO from "src/models/FanDTO";
import FanRunOperationsDTO from "src/models/FanRunOperationsDTO";

interface FanStatusTagProps{
    fanState: FanDTO | null | undefined;
    fanOperationState: FanRunOperationsDTO | null | undefined; 
    desiredFanSettings: FanRunOperationsSettingsDTO | null | undefined;
}

const FanStatusTag : React.FC<FanStatusTagProps> = ({ fanState, fanOperationState, desiredFanSettings }) => {

    if(desiredFanSettings?.fanOperationType === FanOperationType.Automatic){
        if(desiredFanSettings?.useEmcRange && fanOperationState?.isMcWithinLimits === false){
            return(<CustomTag label={'Fans: PAUSED (EMC)'} icon={<PauseCircleOutlined />} color={'orange'}/>);
        }else if(desiredFanSettings?.useTempRange &&fanOperationState?.isTemperatureWithinLimits === false){
            return(<CustomTag label={'Fans: PAUSED (TEMP)'} icon={<PauseCircleOutlined />} color={'orange'}/>);
        }  
        else{
            if(fanState?.isOn === true){
                return(<CustomTag label={'Fans: ON'} icon={<ColumnHeightOutlined />} color={'green'}/>);
            }
        }
    }else if(fanState?.fan?.isOn === true){
        return(<CustomTag label={'Fans: ON'} icon={<ColumnHeightOutlined />} color={'green'}/>);
    }else{
        return(<CustomTag label={'Fans: OFF'} icon={<ColumnHeightOutlined />} color={'red'}/>);
    }
    return(<CustomTag label={'Fans: ??'} icon={<ColumnHeightOutlined />} color={'red'}/>);
}

export default FanStatusTag;